module.exports = __webpack_public_path__ + "files/be7975672923bed60df1e1ee28e5feea.png";